// src/utils/constants.js

// Authentication
export const PINS = {
  ADMIN: '7836',
  STAFF: '4433',
  DRIVER1: '9801',
  DRIVER2: '9802'
};

export const ROLES = {
  ADMIN: 'admin',
  STAFF: 'staff',
  DRIVER1: 'driver1',
  DRIVER2: 'driver2'
};

// Program Information
export const PROGRAM_INFO = {
  name: 'Stemtree of Redmond',
  address: '17634 NE Union Hill Rd, Redmond, WA 98052',
  phone: '(425) 559-7836',
  email: 'redmond@stemtree.com'
};

// Drivers
export const DRIVERS = [
  { id: 'driver1', name: 'Ali A', phone: '(206) 474-7089' },
  { id: 'driver2', name: 'Riley H', phone: '(253) 561-2660' }
];

// Student Status
export const STUDENT_STATUS = {
  PENDING: 'pending',
  PICKED_UP: 'picked-up',
  DELIVERED: 'delivered'
};

// Programs
export const PROGRAMS = [
  {
    id: 'full-day-camp',
    name: 'Full-Day Camp' ,
    subtitle: '9am-4pm • Summer/Fall/Winter/Spring',
    description: 'Full day camp for grades K-8 with Science, Coding, Robotics, Math. One-on-one instruction, customized learning. Please Bring Lunch and Snacks.',
    duration: 'Camp Days: 9am-4pm',
    extendedCare: 'Extended care until 5pm available',
    price: 'From $119/day',
    needsPickup: false,
    image: '/images/camp.png'
  },
  {
    id: 'after-school-dropoff',
    name: 'After School Enrichment',
    subtitle: 'Drop-off Program',
    description: 'Hands-on after school program 4:00-6:00pm (1hr). Science, Math, Robotics, Coding workouts plus homework help.',
    duration: 'Mon-Fri, 4:00-6:00 PM (1hr)',
    price: 'Flexible scheduling 1-5 days/week',
    needsPickup: false,
    image: '/images/dropoff.png'
  },
  {
    id: 'after-school-pickup',
    name: 'After School Program',
    subtitle: 'With School Pickup',
    description: 'Full service with school pickup + enrichment program until 6pm. Science, Math, Robotics, Coding, and supervised play.',
    duration: 'Mon-Fri, Pickup to 6:00 PM',
    price: 'From $320/week',
    needsPickup: true,
    image: '/images/pickup.png'
  },
  {
    id: 'saturday-classes',
    name: 'Saturday Classes',
    subtitle: 'Monthly Program',
    description: 'Saturday morning STEM classes: Robotics, Python, Scratch Coding, Math, Science. One subject per month.',
    duration: 'Saturdays 9:00-10:00 AM',
    price: 'Monthly registration',
    needsPickup: false,
    image: '/images/saturday.png'
  },
  {
    id: 'third-party-billing',
    name: 'Bright Horizons Registration Form Only',
    subtitle: 'For Bright Horizons & Corporate Partners',
    description: 'Annual registration form for students enrolled through corporate partners. Complete this form once per year or for any change of information to update student information.',
    duration: 'No payment required',
    price: 'Bright Horizon Service Partner',
    needsPickup: false,
    image: '/images/BH.png'
  },
  {
  id: 'birthday-parties',
  name: 'Birthday Parties',
  icon: '🎉',
  description: '60 minutes of science or engineering activities included!',
  details: [
    'Duration: 90 minutes',
    'Time: 1:00 PM - 3:00 PM',
    'Themes: Science OR Engineering Workouts',
    '$299 for up to 10 children (minimum)',
    '$399 for 15 children',
    '$25 per additional child (max 20 kids)'
  ],
  needsPickup: false
}
];

// Stripe Payment Links
export const STRIPE_PAYMENT_LINKS = {
  'after-school-pickup': {
    '1': 'https://buy.stripe.com/cNi3cvaqD75c381dBf3AY00',
    '2': 'https://buy.stripe.com/cNi5kDeGT9dk8slfJn3AY01',
    '3': 'https://buy.stripe.com/bJefZhdCP75c0ZT40F3AY02',
    '4': 'https://buy.stripe.com/8x26oHcyLdtAcIB7cR3AY03',
    '5': 'https://buy.stripe.com/cNifZh6an0GO23X1Sx3AY04'
  },
  'after-school-dropoff': {
    '1': 'https://buy.stripe.com/6oU3cv7er9dkeQJcxb3AY05',
    '2': 'https://buy.stripe.com/00wdR9gP1gFM6kd8gV3AY06',
    '3': 'https://buy.stripe.com/6oU4gzgP12OWaAtbt73AY07',
    '4': 'https://buy.stripe.com/eVq4gz1U70GO5g92WB3AY08',
    '5': 'https://buy.stripe.com/dRm00j6an75c9wpfJn3AY09'
  },
  'saturday-classes': {
    'monthly': 'https://buy.stripe.com/5kQ9ATgP12OWcIB0Ot3AY0a'
  },
  'full-day-camp': {
    '1-day': 'https://buy.stripe.com/3cIfZhdCPexE0ZTgNr3AY0b',
    '2-days': 'https://buy.stripe.com/6oUbJ156j9dk23XgNr3AY0c',
    '3-days': 'https://buy.stripe.com/7sY4gzeGT9dk8sl68N3AY0d',
    '4-days': 'https://buy.stripe.com/28EbJ1eGTahocIB1Sx3AY0e',
    '1-week': 'https://buy.stripe.com/dRm6oH42f2OW6kdeFj3AY0f',
    '2-weeks': 'https://buy.stripe.com/6oU7sLfKX1KScIBeFj3AY0g'
  }
};

// API Endpoints
export const API_ENDPOINTS = {
  UPDATE_STUDENT_STATUS: 'https://us-central1-stemtree-pickup-app.cloudfunctions.net/updateStudentStatus',
  UPDATE_DRIVER_STATUS: 'https://us-central1-stemtree-pickup-app.cloudfunctions.net/updateDriverStatus',
};

// Days of Week
export const WEEKDAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
export const WEEKEND = ['Saturday', 'Sunday'];
export const ALL_DAYS = [...WEEKDAYS, ...WEEKEND];

// Grades
export const GRADES = ['Pre-K', 'K', '1', '2', '3', '4', '5', '6', '7', '8'];

// Medical Conditions
export const MEDICAL_CONDITIONS = [
  'None',
  'ADD',
  'ADHD',
  'Auditory Processing',
  'Visual Processing',
  'Dyslexia',
  'Dyscalculia',
  'Dysgraphia',
  'Other'
];

export const MEDICAL_TYPES = [
  'None',
  'Asthma',
  'Allergies',
  'Other'
];

// Relationships
export const RELATIONSHIPS = [
  'Parent',
  'Guardian',
  'Other'
];

// Local Storage Keys
export const STORAGE_KEYS = {
  USER_ROLE: 'stemtree_user_role',
  PENDING_REGISTRATION: 'pendingRegistration'
};

// View Names
export const VIEWS = {
  LOGIN: 'login',
  DRIVER_SELECT: 'driver-select',
  DRIVER_DASHBOARD: 'driver-dashboard',
  STAFF_DASHBOARD: 'staff-dashboard',
  ALL_STUDENTS: 'all-students',
  ADD_STUDENT: 'add-student',
  EDIT_STUDENT: 'edit-student',
  ARCHIVED_STUDENTS: 'archived-students',
  CAMP_ROSTER: 'camp-roster',
  TODAYS_STUDENTS: 'todays-students',
  JOTFORM_SETUP: 'jotform-setup',
  PUBLIC_REGISTER: 'public-register',
  PROGRAM_DETAILS: 'program-details',
  REGISTRATION_FORM: 'registration-form',
  PAYMENT_SUCCESS: 'payment-success'
};

// Status Badge Colors
export const STATUS_COLORS = {
  [STUDENT_STATUS.PENDING]: {
    bg: '#fef3c7',
    text: '#92400e',
    border: '#fcd34d'
  },
  [STUDENT_STATUS.PICKED_UP]: {
    bg: '#dbeafe',
    text: '#1e40af',
    border: '#60a5fa'
  },
  [STUDENT_STATUS.DELIVERED]: {
    bg: '#d1fae5',
    text: '#065f46',
    border: '#6ee7b7'
  }
};

// Status Icons
export const STATUS_ICONS = {
  [STUDENT_STATUS.PENDING]: '⏰',
  [STUDENT_STATUS.PICKED_UP]: '🚗',
  [STUDENT_STATUS.DELIVERED]: '✅'
};

// Form Validation
export const VALIDATION = {
  FORM_VALID_DAYS: 365, // 1 year
  MIN_PHONE_LENGTH: 10,
  MIN_PIN_LENGTH: 4,
  MAX_PIN_LENGTH: 4
};

// Agreement Text
export const AGREEMENT_TEXT = `AGREEMENT TERMS

Parental Consent: By enrolling my child(ren) in any Stemtree program, I agree to the following:

Educational Focus – Stemtree is an educational center focused on science and engineering. It is not a daycare or babysitting service.

Deposit – The first month's payment acts as a non-refundable deposit to reserve a spot.

Payments – A valid credit card is required and will be auto-charged on the 1st of each month.

Cancellation – Written notice is required at least 30 days before the next scheduled monthly payment to cancel participation.

Refunds – No refunds or make-ups are provided for absences due to illness, vacations, or other personal schedule conflicts.

Absence Notification – For safety, parents must call or email Stemtree before pick-up time if a child will be absent or leaving school early.

Facility Policy – Stemtree is a drop-in educational facility. Children are free to come and go at the direction of their parent/guardian, not at the direction of Stemtree.

For Pick-Up Programs (only if your child is enrolled in a pick-up program):

Program Schedule
School Days – Pick-up is provided only on regular school days and on the pre-aligned early dismissal day each week.

No School Days – There is no pick-up or program service on statutory holidays, professional development days, Spring/Winter/Summer Breaks, inclement weather closures, or any unscheduled school closures. Parents must have a back-up plan for these situations.

Parents must promptly inform Stemtree of any absence or change in dismissal time.

Parents must provide correct school address, dismissal time, and emergency contact information.`;


// ==========================================
// STAFF TIME TRACKING SYSTEM
// ==========================================

// Staff Roles
export const STAFF_ROLES = {
  INSTRUCTOR: 'instructor',
  DRIVER: 'driver',
  OPERATIONS: 'operations',
  ADMIN_STAFF: 'admin_staff',
  MANAGER: 'manager'
};

// Work Locations
export const WORK_LOCATIONS = {
  CENTER: {
    id: 'center',
    name: 'Stemtree Center',
    address: '17634 NE Union Hill Rd, Suite 130, Redmond, WA 98052',
    coords: { lat: 47.6755342, lng: -122.1037832 },
    radius: 40000 // feet
  },
  BCA1: {
    id: 'bca1',
    name: 'BCA Bellevue Campus 1',
    address: '14600 NE 24th St, Bellevue, WA 98007',
    coords: { lat: 47.630539, lng: -122.145790 },
    radius: 1000
  },
  BCA2: {
    id: 'bca2',
    name: 'BCA Bellevue Campus 2',
    address: '14640 NE 24th St, Bellevue, WA 98007',
    coords: { lat: 47.630539, lng: -122.145790 },
    radius: 1000
  }
};

// Washington State Break Requirements
export const WA_BREAK_RULES = {
  REST_BREAK: {
    duration: 10, // minutes
    type: 'paid',
    requiredAfter: 4, // hours worked
    description: '10-minute paid rest break every 4 hours'
  },
  MEAL_BREAK: {
    duration: 30, // minutes
    type: 'unpaid',
    requiredAfter: 5, // hours
    description: '30-minute unpaid meal break (optional, but unpaid if taken)'
  }
};

// Time Entry Status
export const TIME_STATUS = {
  CHECKED_IN: 'checked-in',
  ON_BREAK: 'on-break',
  CHECKED_OUT: 'checked-out'
};

// Break Types
export const BREAK_TYPES = {
  PAID_REST: 'paid-rest',
  UNPAID_MEAL: 'unpaid-meal'
};